export default "__VITE_ASSET__HlpOIhus__"